import { raw as ImagePagerDuty } from './pagerduty.svg';
import { raw as ImageSlack } from './slack.svg';
import { raw as ImageWebhook } from './webhook.svg';

export const channelTypeLogo = {
  SlackChannel: ImageSlack,
  PagerDutyChannel: ImagePagerDuty,
  WebhookChannel: ImageWebhook,
};
